import { SideMenuLink } from '../../types/componentsTypes/SideMenu.d';
import HomeIcon from '../../assets/icons/home.svg';
import PaperIcon from '../../assets/icons/paper.svg';
import { Links } from '../../types/enums';

export const sideMenuLinks: SideMenuLink[] = [
  {
    title: 'Home',
    href: Links.HOME,
    iconUrl: HomeIcon,
  },
  {
    title: 'Processos',
    href: Links.PROCESS,
    iconUrl: PaperIcon,
  },
  {
    title: 'Tipo de Processos',
    href: Links.PROCESS_TYPE_FORM,
    iconUrl: PaperIcon,
  },
];
